import React from 'react';
import { twMerge } from 'tailwind-merge';
import { FavoriteCategoryRelayDto } from '@diritto/common/section/favorite-category.dto';

interface FavoriteCategoryProps {
  className?: string;
  item: FavoriteCategoryRelayDto;
  onClick: () => void;
}

const FAVORITE_CATEGORY_STYLES = {
  itemContainer: 'flex flex-col items-center justify-center h-full',
  itemTitle: 'text-center text-white text-xxs font-bold',
  itemDescription: 'text-center opacity-70 text-white text-xxxs font-normal',
} as const;

export const SectionFavoriteCategory = ({ className, item, onClick }: FavoriteCategoryProps) => (
  <div
    key={item.id}
    className={twMerge(
      className,
      'flex flex-col relative rounded-md snap-center snap-always',
      'outline outline-1 outline-offset-[-1px] outline-black/5 overflow-hidden cursor-pointer',
      'md:snap-start',
    )}
    onClick={onClick}
    style={{ width: 228, height: 70, backgroundColor: item.backgroundColor }}>
    <div className={FAVORITE_CATEGORY_STYLES.itemContainer}>
      <div className={FAVORITE_CATEGORY_STYLES.itemTitle}>{item.title}</div>
      <div className={FAVORITE_CATEGORY_STYLES.itemDescription}>{item.description}</div>
    </div>
  </div>
);
